import { SvgIconType } from './svg.interface';

const WebHook: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  square = false,
  color = '#3AA5DC'
}) => (
  <>
    {!square ? (
      <svg
        width={width}
        height={height}
        className={className}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 9.18788C12 7.73814 10.8247 6.56288 9.375 6.56288C9.28071 6.56288 9.18758 6.56785 9.09586 6.57755L7.92068 4.60182C8.35765 4.13297 8.625 3.50396 8.625 2.8125C8.625 1.36275 7.44975 0.1875 6 0.1875C4.55025 0.1875 3.375 1.36275 3.375 2.8125C3.375 3.50396 3.64235 4.13297 4.07932 4.60182L2.90414 6.57755C2.81242 6.56785 2.71929 6.56288 2.625 6.56288C1.17525 6.56288 0 7.73814 0 9.18788C0 10.6376 1.17525 11.8129 2.625 11.8129C3.67215 11.8129 4.57609 11.1997 4.99739 10.3129H7.00261C7.42391 11.1997 8.32785 11.8129 9.375 11.8129C10.8247 11.8129 12 10.6376 12 9.18788ZM10.5 9.18788C10.5 9.8092 9.99632 10.3129 9.375 10.3129C8.75368 10.3129 8.25 9.8092 8.25 9.18788C8.25 8.56656 8.75368 8.06288 9.375 8.06288C9.99632 8.06288 10.5 8.56656 10.5 9.18788ZM2.625 10.3129C3.24632 10.3129 3.75 9.8092 3.75 9.18788C3.75 8.56656 3.24632 8.06288 2.625 8.06288C2.00368 8.06288 1.5 8.56656 1.5 9.18788C1.5 9.8092 2.00368 10.3129 2.625 10.3129ZM7.125 2.62538C7.125 3.2467 6.62132 3.75038 6 3.75038C5.37868 3.75038 4.875 3.2467 4.875 2.62538C4.875 2.00406 5.37868 1.50038 6 1.50038C6.62132 1.50038 7.125 2.00406 7.125 2.62538Z"
          fill={'#6A7383'}
        />
      </svg>
    ) : (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="6" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 20.2494C24 18.3164 22.433 16.7494 20.5 16.7494C20.3743 16.7494 20.2501 16.756 20.1278 16.769L18.5609 14.1347C19.1435 13.5095 19.5 12.6708 19.5 11.7489C19.5 9.8159 17.933 8.2489 16 8.2489C14.067 8.2489 12.5 9.8159 12.5 11.7489C12.5 12.6708 12.8565 13.5095 13.4391 14.1347L11.8722 16.769C11.7499 16.756 11.6257 16.7494 11.5 16.7494C9.567 16.7494 8 18.3164 8 20.2494C8 22.1824 9.567 23.7494 11.5 23.7494C12.8962 23.7494 14.1015 22.9319 14.6632 21.7494H17.3368C17.8985 22.9319 19.1038 23.7494 20.5 23.7494C22.433 23.7494 24 22.1824 24 20.2494ZM22 20.2494C22 21.0778 21.3284 21.7494 20.5 21.7494C19.6716 21.7494 19 21.0778 19 20.2494C19 19.421 19.6716 18.7494 20.5 18.7494C21.3284 18.7494 22 19.421 22 20.2494ZM11.5 21.7494C12.3284 21.7494 13 21.0778 13 20.2494C13 19.421 12.3284 18.7494 11.5 18.7494C10.6716 18.7494 10 19.421 10 20.2494C10 21.0778 10.6716 21.7494 11.5 21.7494ZM17.5 11.4994C17.5 12.3278 16.8284 12.9994 16 12.9994C15.1716 12.9994 14.5 12.3278 14.5 11.4994C14.5 10.671 15.1716 9.99941 16 9.99941C16.8284 9.99941 17.5 10.671 17.5 11.4994Z"
          fill="white"
        />
      </svg>
    )}
  </>
);

export default WebHook;
